import { ListingForm } from 'components/shared/TableListing';
import { Nullable } from 'global';
import { CreateBPFTemplateInput, Template } from '../api';
import { StagesFormValues, TemplateConstructorMode, TemplateFormValues } from '../types';
import { initialStagesConstructorFormValue, stagesConstructorFormRow } from '../constants';

class StagesMapper {
  processStageFields(stage: StagesFormValues): CreateBPFTemplateInput['stages'][number]['stageFields'] {
    return [
      {
        field: 'checklist',
        value: stage.checklist.map(({ name, isRequired }) => ({ name, isRequired, value: false })),
      },
    ];
  }

  processFormValuesToCreateOrUpdateDto(input: {
    accountId: string;
    mode: TemplateConstructorMode;
    templateValues: TemplateFormValues;
    stagesValues: ListingForm<StagesFormValues>;
  }): CreateBPFTemplateInput {
    const { stagesValues, mode, accountId, templateValues } = input;

    return {
      accountId,
      name: templateValues.templateName,
      isActive: templateValues.isActive,
      departmentId: templateValues.businessProcess,
      applyRules: {
        paymentType: templateValues.applyRules.paymentType,
      },
      stages: stagesValues.bodyFields.map((stage, index) => ({
        ordinal: index,
        name: stage.name,
        completionRules: {},
        stageFields: this.processStageFields(stage),
        ...(stage.id && mode === 'edit' ? { id: stage.id } : {}),
      })),
    };
  }

  processTemplateToFormValues(template: Template): TemplateFormValues {
    return {
      ...initialStagesConstructorFormValue,
      isActive: template.isActive,
      templateName: template.name,
      businessProcess: template.department.id,
      ...(Object.keys(template.applyRules).length
        ? {
            applyRules: template.applyRules,
            ...initialStagesConstructorFormValue.applyRules,
          }
        : { applyRules: initialStagesConstructorFormValue.applyRules }),
    };
  }

  processTemplateToConstructorFormValues(template: Nullable<Template>): StagesFormValues[] {
    if (!template) return [{ ...stagesConstructorFormRow }];

    return template.stages.map(({ businessProcessFlowStageId, name, stageFields }) => ({
      name,
      id: businessProcessFlowStageId,
      checklist: (Array.isArray(stageFields) ? stageFields : []).reduce<StagesFormValues['checklist']>(
        (acc, stageField) => {
          if (stageField.field !== 'checklist') return acc;

          stageField.value.forEach(fieldData => {
            acc.push({ ...fieldData, value: fieldData.value ?? false });
          });

          return acc;
        },
        []
      ),
    }));
  }
}

export const stagesMapper = new StagesMapper();
